import SearchBar from 'components/search_bar/search_bar.vue'
import { mapActions, mapState } from 'pinia'

import { useInstanceStore } from 'src/stores/instance.js'
import { useInterfaceStore } from 'src/stores/interface'
import { useMergedConfigStore } from 'src/stores/merged_config.js'
import { useStreamingStore } from 'src/stores/streaming.js'
import { useUsersStore } from 'src/stores/users.js'

import { WSConnectionStatus } from 'src/api/websocket.js'
import { confirmLogout } from 'src/services/confirm/confirm.js'

export default {
  components: {
    SearchBar,
  },
  data: () => ({
    searchBarHidden: true,
    supportsMask:
      window.CSS?.supports &&
      (window.CSS.supports('mask-size', 'contain') ||
        window.CSS.supports('-webkit-mask-size', 'contain') ||
        window.CSS.supports('-moz-mask-size', 'contain') ||
        window.CSS.supports('-ms-mask-size', 'contain') ||
        window.CSS.supports('-o-mask-size', 'contain')),
  }),
  computed: {
    enableMask() {
      return this.supportsMask && this.logoMask
    },
    logoStyle() {
      return {
        visibility: this.enableMask ? 'hidden' : 'visible',
      }
    },
    logoMaskStyle() {
      return this.enableMask
        ? {
            'mask-image': `url(${this.logo})`,
          }
        : {
            'background-color': this.enableMask ? '' : 'transparent',
          }
    },
    logoBgStyle() {
      const mask = this.enableMask
        ? {}
        : { 'background-color': this.enableMask ? '' : 'transparent' }

      return {
        margin: `${this.logoMargin} 0`,
        opacity: this.searchBarHidden ? 1 : 0,
        ...mask,
      }
    },
    ...mapState(useInstanceStore, ['privateMode']),
    ...mapState(useInstanceStore, {
      logoMask: (store) => store.instanceIdentity.logoMask,
      logo: (store) => store.instanceIdentity.logo,
      logoLeft: (store) => store.instanceIdentity.logoLeft,
      logoMargin: (store) => store.instanceIdentity.logoMargin,
      sitename: (store) => store.instanceIdentity.name,
      hideSitename: (store) => store.instanceIdentity.hideSitename,
    }),
    ...mapState(useUsersStore, ['currentUser']),
    ...mapState(useStreamingStore, {
      streamingConnected: (store) => store.state === WSConnectionStatus.JOINED,
      streamingWorked: (store) => store.held,
    }),
    ...mapState(useMergedConfigStore, ['mergedConfig']),
    // on by default: a server that never takes it is polled without a word
    streamingEnabled() {
      return this.mergedConfig.useStreamingApi && this.streamingWorked
    },
    streamingTooltip() {
      if (this.streamingConnected) {
        return this.$t('timeline.socket_reconnected')
      } else {
        return this.$t('timeline.socket_disconnected')
      }
    },
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0)
    },
    async logout() {
      if (await confirmLogout(this.$t)) this.doLogout()
    },
    async doLogout() {
      await useUsersStore().logout()
      this.$router.replace('/main/public')
    },
    onSearchBarToggled(hidden) {
      this.searchBarHidden = hidden
    },
    ...mapActions(useInterfaceStore, ['openSettingsModal']),
  },
}
